import React, { useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { filter, map, isEmpty } from "lodash";
import { startGame } from "redux/GameAction";
import ApiEngine from "util/ApiEngine";
import { ApiUrl, ApiKey, AlertTypes, WebUrl, SessionKey, LanguageOption, _MAIN_WALLET_ID } from "util/Constant";
import { stringIsNullOrEmpty, numberWithCurrencyFormat, createFormBody } from "../../util/Util";
import PropTypes from "prop-types";
import { useRouteMatch, useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Modal, ModalBody, ModalHeader } from "reactstrap";
import { useForm } from "react-hook-form";
import moment from "moment";
import {
  setDisplayLogin,
  setDisplayRegister,
  setBusy,
  setIdle,
  showMessage,
  showResponseMessage
} from "../../redux/AppAction";
import UMIcon from "../../assets/img/icon/dashboardv2_um.png";
import BottomSuccessModal from "../../components/custom/BottomSuccessModal";
import reloadPasswordIcon from "../../assets/img/icon/reset_password.svg";
import Icon from "@mdi/react";
import { mdiContentCopy } from "@mdi/js";
import Spinner from 'react-bootstrap/Spinner';
import SweetAlert from "react-bootstrap-sweetalert";



const GameSectionV3 = (props) => {
  const { t } = useTranslation();
  const _dispatch = useDispatch();
  const _history = useHistory();
  var url_string = window.location;
  var url = new URL(url_string);
  const match = useRouteMatch(url.pathname);
  var selectedLanguage = localStorage.getItem(SessionKey._LANGUAGE) && localStorage.getItem(SessionKey._LANGUAGE) != 'undefined' ?
    localStorage.getItem(SessionKey._LANGUAGE) : 'en';

  const { isLoggedIn } = useSelector((state) => state.authState);
  let title = "";

  if (match) {
    const { path } = match;
    const value = path.replace('/', '');
    title = value;
  }

  var gameCategories = useSelector((state) =>  state.gameState.gameCategories );

  const [activeCategory, setActiveCategory] = useState("Casino");
  const [availableMasterProducts, setAvailableMasterProducts] = useState([]);
  const [availableFilteredMasterProducts, setAvailableFilteredMasterProducts] = useState([]);
  const [availableSlotsProviders, setAvailableSlotsProviders] = useState([]);
  const [selectedProviders, setSelectedProviders] = useState("");
  const [productGameList, setProductGameList] = useState([]);
  const [productGameListTotal, setProductGameListTotal] = useState(0);

  const [activeLanguageId, setActiveLanguageId] = useState(1);
  const [isLoadingProvidersList, setIsLoadingProvidersList] = useState(false);
  const [isLoadingSlotGameList, setIsLoadingSlotGameList] = useState(false);
  const [selectedSlotsProviderName, setSelectedSlotsProviderName] = useState("NextSpin");

  const [startX, setStartX] = useState(0);
  const [scrollLeft, setScrollLeft] = useState(0);
  const [isDragging, setIsDragging] = useState(false);
  const [isGrabbing, setIsGrabbing] = useState(false);
  const [mouseDownTime, setMouseDownTime] = useState(null);

  let containerRef = useRef();
  const LONG_PRESS_DURATION = 300;
  const [loading, setLoading] = useState({});
  //use Effect function

  useEffect(() => {
    if (props.data.length > 0) {
      setAvailableMasterProducts(props.data.filter(x => !stringIsNullOrEmpty(x.productImage)));
      setAvailableFilteredMasterProducts(props.data.filter(x => !stringIsNullOrEmpty(x.productImage) && x.categoryName === activeCategory));
      setAvailableSlotsProviders(props.data.filter(x => !stringIsNullOrEmpty(x.productImage) && x.categoryName === "Slots"));
      checkIsLoading(activeCategory);
    }
  },[props.data])

 
  useEffect(() => {
    if (localStorage.getItem(SessionKey._LANGUAGE) && localStorage.getItem(SessionKey._LANGUAGE) != "undefined") {
      let tempLangId = LanguageOption.filter(x => x.code === localStorage.getItem(SessionKey._LANGUAGE))[0].languageId;
      setActiveLanguageId(tempLangId);
    }
  }, [localStorage.getItem(SessionKey._LANGUAGE)]);

  //handle catergory click
  const handleCategoryClick = async (category) => {
    _dispatch(setBusy());
    checkIsLoading(category);
    if (!isLoadingProvidersList) {
      setActiveCategory(category);
        filteredAvailableMasterProducts(category);
        if (category !== activeCategory) {
            if (category === "Slots") {
                handleProviderClick(availableMasterProducts.filter(x => x.categoryName === category && x.hasOwnLobby)[0]);
            } else {
                setSelectedProviders("");
            }
        }

    }
    _dispatch(setIdle());
  }

  //filtered available master products
  const filteredAvailableMasterProducts = async (category) => {
    if (category !== "All") {
      setAvailableFilteredMasterProducts(availableMasterProducts.filter(x => x.categoryName === category))
    } else {
      setAvailableFilteredMasterProducts(availableMasterProducts);
    }

  }

  // retrieve product game list by provider name
  const handleSlotsProviderClick = async (productName, category) => {
    if (!isDragging) {
      setSelectedProviders(productName);
      setIsLoadingSlotGameList(true)
      var responseJson = await ApiEngine.get(
        ApiUrl._API_GET_PRODUCT_GAMES_LIST_DASHBOARD + "?languageId=" + activeLanguageId + (category === "" ? "" : "&category=" + category) + ("&providerName=" + productName) + ("&start=0&count=18")
      );
      if (responseJson[ApiKey._API_SUCCESS_KEY]) {
        setProductGameList(responseJson[ApiKey._API_DATA_KEY][ApiKey._API_DATA_KEY]);
        setProductGameListTotal(responseJson[ApiKey._API_DATA_KEY]['totalCount'])
        setIsLoadingSlotGameList(false);
      } else {
        setIsLoadingSlotGameList(false);
      }
    }
  }

  // check provider has lobby or redirect start game
  async function handleProviderClick(provider) {
    setSelectedSlotsProviderName(provider.productName);
    if (isLoggedIn) {
      if (provider.hasOwnLobby) {
        setSelectedProviders(provider.productName);
        if (provider.categoryName === "Slots") {
          setActiveCategory(provider.categoryName);
          handleSlotsProviderClick(provider.productName, provider.categoryName);
        } else {
          _history.push({
            pathname: WebUrl._URL_GAME_LIST.replace(":provider", provider.productName),
          });
        }
      } else {
        if (provider.game != null && provider.game["gameUm"] !== true) {
          _dispatch(startGame(provider.productGame));
        } else {
          _dispatch(
            showMessage({
              type: AlertTypes._INFO,
              content: t("GAME_UM"),
              onConfirm: () => {
                //console.log("hi");
              },
            })
          );
        }
      }

    }
    else {
      if (provider.hasOwnLobby) {
        setSelectedProviders(provider.productName);
        if (provider.categoryName === "Slots") {
          setActiveCategory(provider.categoryName);
          handleSlotsProviderClick(provider.productName, provider.categoryName);
        } else {
          _history.push({
            pathname: WebUrl._URL_GAME_LIST.replace(":provider", provider.productName),
          });
        }
      } else {
        _dispatch(
          showMessage({
            type: AlertTypes._INFO,
            content: t("PLEASE_LOGIN_FIRST"),
            onConfirm: () => {
              //console.log("hi");
            },
          })
        );
      }
    }
  }


  const scrollToPosition = (isBtn, leftOrRight, productName) => {
    var position;
    let containerDiv = document.getElementById("providerList");
    let fullDivLength = containerDiv.scrollWidth;
    var totalper = fullDivLength / availableSlotsProviders.length;
    if (isBtn) {
      if (leftOrRight === "left" && containerRef.current.scrollLeft > (totalper * 7)) {
        position = containerRef.current.scrollLeft - (totalper * 7);
      }
      else if (leftOrRight === "right" && containerRef.current.scrollLeft < (fullDivLength - (totalper * 7))) {
        position = containerRef.current.scrollLeft + (totalper * 7);
      }
    }
    else {
      const index = availableSlotsProviders.findIndex(e => e.productName === productName);
      if (index !== -1) {
        if (containerRef.current) {
          position = totalper * (index);
        }
      }
    }
    containerRef.current.scrollLeft = position;
  };

  const ToLobby = () => {
    if (!stringIsNullOrEmpty(selectedProviders)) {
      _history.push({

        pathname: WebUrl._URL_GAME_LIST.replace(":provider", selectedProviders),
      });
    }
  }
;

  const handleMouseDown = (e) => {
    setStartX(e.clientX);
    setScrollLeft(containerRef.current.scrollLeft);
    setMouseDownTime(new Date().getTime());
    setIsGrabbing(true);
    setIsDragging(true);
  };

  const handleMouseMove = (e) => {
    if (isDragging && isGrabbing) {
      const deltaX = e.clientX - startX;
      const containerRect = containerRef.current.getBoundingClientRect();
      const containerWidth = containerRef.current.clientWidth;
      const containerHeight = containerRef.current.clientHeight;

      if (
        e.clientX < containerRect.left ||
        e.clientX > containerRect.left + containerWidth ||
        e.clientY < containerRect.top ||
        e.clientY > containerRect.top + containerHeight
      ) {

        setIsDragging(false);
        setIsGrabbing(false);
        return;
      }

      containerRef.current.scrollLeft = scrollLeft - deltaX;
    }
  };

  const handleMouseUp = (e) => {
    setIsGrabbing(false);
    const currentTime = new Date().getTime();
    if (currentTime - mouseDownTime < LONG_PRESS_DURATION) {
      setIsDragging(false);
    }
  };

  const handleSelectStart = (e) => {
    if (isDragging) {
      e.preventDefault();
    }
  };

  useEffect(() => {
  }, [gameCategories])

  //<div className="slots-left-right-btn">
  //  <div className="left-btn" onClick={() => scrollToPosition(true, "left")}>{"<"}</div>
  //  <div className="right-btn" onClick={() => scrollToPosition(true, "right")}>{">"}</div>
  //</div>

  const handleImageLoad = (id) => {
    setLoading((prevLoading) => ({ ...prevLoading, [id]: false }));
  };

  const checkIsLoading = async (category) => {
    setLoading(props.data.filter(x => !stringIsNullOrEmpty(x.productImage) && x.categoryName === category).reduce((acc, provider) => ({ ...acc, [provider.productId]: true }), {}));
  }


  useEffect(() => {
    if (!Object.values(loading).every(value => value === false)) {
      const falseKeys = Object.entries(loading)
        .filter(([key, value]) => value) // Filter for false values
        .map(([key]) => key);
      falseKeys.forEach((x) => {
        handleImageLoad(x);
      });
    }
  }, [loading, !Object.values(loading).every(value => value === false)]);

  return (
    <div className="text-center mt-4">
      <ul className="game-section-v3-category-box list-inline mb-0" onClick={() => localStorage.setItem(SessionKey._ISONLOAD, true)}>
        {gameCategories &&
          gameCategories.length > 0 &&
          map(gameCategories.filter(x => x.originalTitle !== "Virtual-Sports" && x.originalTitle !== "V.Sports" && x.originalTitle !== "Fish Games"), (item, index) => {
            return (
              <li key={"game_categories_" + index} className={activeCategory === item.originalTitle ? "active" : ""} onClick={() => handleCategoryClick(item.originalTitle)}>
                <div className="cat-item">
                  <div className='cat-img'>
                    <img
                      //src={`/img/version3/game-section-v3/game-categories/${item.originalTitle}.svg`}
                      src={"https://cdn.i8global.com/i8app/product-category/icon-" + item.originalTitle + ".svg"}
                      className='img-responsive'
                      alt={item.title}
                    />
                  </div>
                  <div className={'cat-details' + (item.originalTitle === "Connect" ? " connect-font" : "")}>{t(item.originalTitle)}</div>
                </div>
              </li>
            );
          })}
      </ul>

      {isLoadingProvidersList ? <div className="game-section-loading">
        <Spinner animation="border"
          role="status"
          size="xl"
          style={{ verticalAlign: "middle", marginLeft: "10px" }}>
          <span className="sr-only">{t("LOADING")}...</span>
        </Spinner>
      </div> :
        activeCategory === "Slots" && !stringIsNullOrEmpty(selectedProviders) ?
          availableSlotsProviders &&
          availableSlotsProviders.length > 0 &&
          <div className="slot-provider-wrapper mt-4">
            <div className="scroll-left-btn" onClick={() => scrollToPosition(true, "left")}>{"<"}</div>
              <ul className={`game-section-v3-slots-provider-box list-inline ${isGrabbing && "dragging" }`} id="providerList" ref={containerRef}
              onMouseDown={(e) => handleMouseDown(e)}
              onMouseMove={(e) => handleMouseMove(e)}
              onMouseUp={(e) => handleMouseUp(e)}
              onSelectStart={(e) => handleSelectStart(e)}
              onLoad={() => scrollToPosition(false, "", selectedSlotsProviderName)}>
            {availableSlotsProviders.map((provider, index) => {
              return (
                <li
                  key={"game_slots_provider_" + index}
                  className={(selectedProviders === provider.productName ? "active" : "") + (provider.isUM ? " is-um um-display" : "")}
                  style={{ cursor: isGrabbing ? "grabbing" : provider.isUM ? "not-allowed" : "pointer" }}
                  onClick={() => {
                    if (!provider.isUM) {
                      handleSlotsProviderClick(provider.productName, provider.categoryName);
                    }
                  }}>
                  <img
                    src={`/img/version3/game-section-v3/game-slots-providers/${provider.productName}.png`}
                    className='img-responsive'
                    alt={provider.title}
                    draggable="false"
                  />
                  {provider.isUM &&
                    <div
                      style={{
                        backgroundImage: `url(${UMIcon})`,
                        zIndex: 1
                      }}
                      className="v2-um-tag-icon"
                    ></div>
                  }
                </li>
              );
            })}
            </ul>
            <div className="scroll-right-btn" onClick={() => scrollToPosition(true, "right")}>{">"}</div>
          </div>
          :
          availableFilteredMasterProducts && availableFilteredMasterProducts.length > 0 &&
          <>
            <div className="game-section-v3-provider-container">
              {availableFilteredMasterProducts.map((provider, index) => {
                return (
                  <div
                    key={"game-section-v3-provider-" + index}
                    className="provider-items"
                    style={{ cursor: provider.isUM ? "not-allowed" : "pointer" }}
                    onClick={() => {
                      if (!provider.isUM) {
                        handleProviderClick(provider);
                      }
                    }}>
                    <img
                      src={provider.productImage}
                      alt="provider"
                      className="w-100"
                      style={{
                        filter: provider.isUM ? "grayscale(1)" : "unset",
                        display: loading[provider.productId] ? "none" : "block"
                      }}
                      onClick={() => { }}
                      onLoad={() => handleImageLoad(provider.productId)}
                    />
                    {provider.isUM &&
                      <div className="game-category-um"></div>
                    }
                    {provider.isUM &&
                      <div
                        style={{
                          backgroundImage: `url(${UMIcon})`,
                          zIndex: 1
                        }}
                        className="v2-um-tag-icon"
                      ></div>
                    }
                  </div>)
              })
              }
            </div>
          </>
      }

      {isLoadingSlotGameList ?
        <div className="game-section-loading">
          <Spinner animation="border"
            role="status"
            size="xl"
            style={{ verticalAlign: "middle", marginLeft: "10px" }}>
            <span className="sr-only">{t("LOADING")}...</span>
          </Spinner>
        </div> :
        activeCategory === "Slots" && productGameList && productGameList.length > 0 &&
        <>
          <div className="product-games-list-container" style={{ paddingTop: '35px' }} >

            {productGameList.map((game, i) => {
              return (
                <div className="product-games-list-items">

                  <div className={"product-game-box desktop " + (isLoggedIn ? game["gameUm"] === true ? "game-um" : "cursor-pointer" : "")} onClick={() => {
                    if (game["gameUm"] !== true) {
                      /*startGame(game["id"], game["gameName"], game["isApp"], game["appUrl"], game["appDeepLink"], game["packageNameKeyword"], game.product["id"], game.product["isSeamless"], game.productCategory["originalTitle"])*/
                      //_dispatch(startGame(game));
                      if (!game.product["hasDemoGame"]) {
                        if (game["gameUm"] !== true) {
                          _dispatch(startGame(game, false, _history));
                        }
                      }
                    }
                  }}>
                    {game["isNewGame"] || game["isRecommended"] ? (
                      <div className="tag">
                        <img
                          src={
                            game["isRecommended"]
                              ? "/img/assets/hot.svg"
                              : "/img/assets/new.svg"
                          }
                          className="img-responsive"
                          alt={game["isRecommended"] ? "hot" : "new"}
                          loading="lazy"
                        />
                      </div>
                    ) : null}

                    <div
                      className="product-game-image"
                      style={{
                        backgroundImage:
                          (isLoggedIn
                            ? game["gameUm"] == true
                              ? "linear-gradient(rgba(0,0,0,.8), rgba(0,0,0,.8)), "
                              : " "
                            : " ") /*+ `url(${encodeURI(game["image"])})`*/,
                        position: "relative",
                        backgroundPosition: "center",
                        backgroundRepeat: "no-repeat",
                        borderRadius: "16px",
                      }}
                    >
                      {isLoggedIn && game["gameUm"] == true && (
                        <>
                          <div
                            style={{
                              backgroundImage: `url(${UMIcon})`,
                              zIndex: 1
                            }}
                            className="v2-um-tag-icon"
                          ></div>
                        </>
                      )}
                      <img
                        src={game["image"]}
                        alt="Game provider"
                        style={{
                          position: "relative",
                          backgroundPosition: "center",
                          backgroundRepeat: "no-repeat",
                          borderRadius: "16px",
                          opacity: game["gameUm"] == true ? "0.7" : "1"
                        }}
                        loading="lazy"
                      />
                      {game.product["hasDemoGame"] &&
                        <div className="button-overlay">
                          {isLoggedIn &&
                            <>
                              <button className="real-button" onClick={() => {
                                if (game["gameUm"] !== true) {
                                  _dispatch(startGame(game, false, _history));
                                }
                              }}>
                                {t("REAL_PLAY")}
                              </button>
                            </>
                          }
                          <button className="demo-button" onClick={() => {
                            if (game["gameUm"] !== true) {
                              _dispatch(startGame(game, true, _history));
                            }
                          }}>
                            {t("FUN_PLAY")}
                          </button>
                        </div>
                      }
                    </div>
                    <div className="product-game-name">
                      {game["gameName"]}
                    </div>
                  </div>

                </div>
              )
            })}
          </div>

          {productGameListTotal > 18 && <button className="more-games-button" onClick={ToLobby}>{t("MORE_GAMES")}</button>
          }
        </>
      }
      <hr className="hr-right-new" />
    </div>
  );
};

export default GameSectionV3;
